import { FC, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FilterContent from "./FilterContent";

const Filter: FC<{
  handleFilterData: (value: {
    surname: string;
    name: string;
    patronymic: string;
    section: string;
    workPosition: string;
  }) => void;
}> = ({ handleFilterData }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleToggleFilterContent = () => setIsFilterOpen((prev) => !prev);

  return (
    <Box display="flex" mt={1} ml={1} gap={1} height={40}>
      <Button
        variant="contained"
        size="small"
        onClick={handleToggleFilterContent}
      >
        {isFilterOpen ? "Скрыть" : "Фильтр"}
      </Button>
      {isFilterOpen && <FilterContent onClick={handleFilterData} />}
    </Box>
  );
};

export default Filter;
